"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLastActivityCache = exports.getLastActivityCache = exports.generateSession = exports.cacheSession = exports.supportsSessionStorage = void 0;
const uuid_1 = require("uuid");
const lodash_once_1 = __importDefault(require("lodash.once"));
const get_date_string_1 = __importDefault(require("./get-date-string"));
const constants_1 = require("../constants");
const datetime_1 = require("./datetime");
exports.supportsSessionStorage = lodash_once_1.default(() => {
    const value = '_OMBORI_GRID_SIGNALS_SESSION_STORAGE_TEST';
    try {
        sessionStorage.setItem(value, value);
        sessionStorage.removeItem(value);
        return true;
    }
    catch (e) {
        return false;
    }
});
const getCachedSession = () => {
    try {
        const sessionStringCache = sessionStorage.getItem(constants_1.SESSION_CACHE_KEY);
        if (!sessionStringCache)
            return null;
        return JSON.parse(sessionStringCache);
    }
    catch (e) {
        return null;
    }
};
exports.cacheSession = (sessionId, sessionCreated) => {
    sessionStorage.setItem(constants_1.SESSION_CACHE_KEY, JSON.stringify({ sessionId, sessionCreated }));
};
exports.generateSession = ({ forceCreateNewSession = false, maxSessionLastActivityMins, }) => {
    const sessionId = uuid_1.v4();
    const sessionCreated = get_date_string_1.default();
    if (exports.supportsSessionStorage()) {
        const cachedSession = getCachedSession();
        if (!forceCreateNewSession &&
            cachedSession &&
            cachedSession.sessionId &&
            cachedSession.sessionCreated) {
            const lastActivity = exports.getLastActivityCache();
            if (lastActivity) {
                const isAfterMins = datetime_1.getDifInMins(get_date_string_1.default(), lastActivity) >= maxSessionLastActivityMins;
                if (!isAfterMins) {
                    return {
                        sessionId: cachedSession.sessionId,
                        sessionCreated: cachedSession.sessionCreated,
                        isFromCache: true,
                    };
                }
            }
        }
        exports.cacheSession(sessionId, sessionCreated);
        exports.setLastActivityCache(sessionCreated);
    }
    return { sessionId, sessionCreated, isFromCache: false };
};
exports.getLastActivityCache = () => {
    try {
        if (!exports.supportsSessionStorage())
            return null;
        const lastActivityCache = sessionStorage.getItem(constants_1.LAST_ACTIVITY_CACHE_KEY);
        return lastActivityCache;
    }
    catch (e) {
        return null;
    }
};
exports.setLastActivityCache = (dateString) => {
    try {
        if (!exports.supportsSessionStorage())
            return false;
        sessionStorage.setItem(constants_1.LAST_ACTIVITY_CACHE_KEY, dateString);
        return dateString;
    }
    catch (e) {
        return false;
    }
};
